(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/bingo-react/components/bingo-card/assets/javascripts/partials/countdown-timer.js') >= 0) return;  svs.modules.push('/modules/bingo-react/components/bingo-card/assets/javascripts/partials/countdown-timer.js');
"use strict";

const {
  GameRoomStatus
} = svs.bingo_react.components.common.constants;
const useStartTimer = svs.bingo_react.components.useStartTimer;
const CountdownTimer = _ref => {
  let {
    startTime,
    status
  } = _ref;
  const timer = useStartTimer(startTime, status);
  if (status === GameRoomStatus.STARTING || !timer) {
    return React.createElement("div", {
      className: "bingo-card-countdown"
    }, React.createElement("span", {
      "aria-live": "off",
      className: "bingo-card-countdown__blinking-text"
    }, "00:00"));
  }
  return React.createElement("div", {
    className: "bingo-card-countdown"
  }, React.createElement("span", {
    "aria-live": "off"
  }, "".concat(timer.minutes.toString().padStart(2, '0'), ":").concat(timer.seconds.toString().padStart(2, '0'))));
};
setGlobal('svs.bingo_react.components.bingoCard.CountdownTimer', CountdownTimer);

 })(window);